// @owners { team: patients-team }
import { SPACING } from '@alto/design-library-tokens';
import { type AddOnOtc } from '@alto/scriptdash/alto/patient_app/add_ons/types/v1/add_on_otc';
import React from 'react';
import styled from 'styled-components';
import { ProductItem } from './ProductItem';

type ProductScrollViewProps = {
  readonly count: number;
  readonly products: AddOnOtc[];
  readonly categoryName: string;
  readonly searchQuery?: string;
  readonly scrollOverflow?: boolean;
  readonly isStoreItems?: boolean;
};

/** Clips negative-margin bleed so the page does not gain horizontal scroll. */
const ScrollViewOuter = styled.div<{ $scrollOverflow?: boolean }>`
  width: 100%;
  min-width: 0;
  overflow-x: hidden;
  margin: 0 ${({ $scrollOverflow }) => ($scrollOverflow ? `-${SPACING.STATIC.LG.px}` : '0')};
`;

const StyledScrollViewList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  padding: 0 ${SPACING.STATIC.LG.px};
  margin: 0;
  gap: ${SPACING.STATIC.SM.px};
  overflow-x: auto;
  overflow-y: hidden;
  overscroll-behavior-x: contain;
  contain: inline-size;
  -webkit-overflow-scrolling: touch;
`;

export const ProductScrollView = ({
  count,
  products,
  categoryName,
  scrollOverflow,
  searchQuery,
  isStoreItems,
}: ProductScrollViewProps) => {
  return (
    <ScrollViewOuter $scrollOverflow={scrollOverflow}>
      <StyledScrollViewList>
        {products.map((product, index) => (
          <ProductItem
            categoryName={categoryName}
            key={product.sku}
            count={count}
            product={product}
            index={index}
            searchQuery={searchQuery}
            isStoreItem={isStoreItems}
            isInScrollView
          />
        ))}
      </StyledScrollViewList>
    </ScrollViewOuter>
  );
};
